import { Box, Card, CardContent, Stack, Typography, Button, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { personalDataStore } from 'stores/personalDataStore';

const PaymentSuccessPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const formId = searchParams.get('Shp_formId') ?? '';
  const outSum = searchParams.get('OutSum') ?? searchParams.get('out_summ') ?? '';

  useEffect(() => {
    // Источник правды — ResultURL (сервер-сервер) уже отметил платёж.
    // Здесь только обновляем локальное состояние оплат.
    personalDataStore.getPayments();
  }, []);

  const handleContinue = () => {
    navigate(formId ? `/payment/${formId}` : '/main');
  };

  return (
    <Stack
      sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', px: 2 }}
    >
      <Card
        sx={{
          maxWidth: 520,
          width: '100%',
          boxShadow: theme.shadows[10],
          borderRadius: 3
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                backgroundColor: theme.palette.success.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white'
              }}
            >
              <Icon icon="mdi:check-bold" width={36} height={36} />
            </Box>

            <Typography variant="h5" fontWeight={700}>
              Оплата прошла успешно
            </Typography>

            <Typography variant="body1" color="text.secondary">
              {outSum ? `Платёж на ${outSum} ₽ подтверждён. ` : ''}
              Доступ к интервью открыт.
            </Typography>

            <Button
              size="large"
              variant="contained"
              fullWidth
              onClick={handleContinue}
              sx={{ mt: 2, py: 1.5, fontWeight: 600 }}
              startIcon={<Icon icon="mdi:arrow-right" />}
            >
              Продолжить
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default observer(PaymentSuccessPage);
